import ArrowRight from "../../../assets/arrow.svg";
import ArrowLeft from "../../../assets/arrowLeft.svg";

export default function ScrollOval(props) {
  const { type, index, setIndex, setIsDecrease } = props;

  return (
    <div
      style={{
        position: "absolute",
        right: type === "right" ? 0 : null,
        left: type === "left" ? 0 : null,
        width: "90px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "120px",
          height: "120px",
          marginLeft: type === "right" ? "38px" : "-68px",
          boxShadow: "0 0 9px 0 #00000028",
          backgroundColor: "#fff",
          borderTopRightRadius: type === "right" ? 0 : "50%",
          borderBottomRightRadius: type === "right" ? 0 : "50%",
          borderTopLeftRadius: type === "left" ? 0 : "50%",
          borderBottomLeftRadius: type === "left" ? 0 : "50%",
          borderRadius: "50%",
          right: 0,
          cursor: "pointer",
          display: "flex",
          justifyContent: type === "right" ? "flex-start" : "flex-end",
        }}
        onClick={() => {
          setIsDecrease(type === "left" ? true : false);
          setIndex(
            type === "left" ? index - 1 : type === "right" ? index + 1 : index
          );
        }}
      >
        <div
          style={{
            width: "50%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {type === "right" ? (
            <img
              src={ArrowRight}
              alt="right"
              style={{ height: "21px", width: "23px" }}
            />
          ) : (
            <img
              src={ArrowLeft}
              alt="left"
              style={{ height: "21px", width: "23px" }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
